import React from "react";
import "./index.scss";

const BusinessClassification = () => {
  return (
    <div className="business-main">
      {/* Banner */}

      <div id="banner-area">
        <div className="about-overlay"></div>
        <div className="banner-title-content">
          <h2>Business Classifications</h2>
        </div>
      </div>

      {/* Main */}

      <div className="page-header">
        Computer Data Concepts Inc is a Minority Owned Business Enterprise.
      </div>
<div>

      <div className="row">
        {/* Card 1 */}
        <div className="card-main">
          <img
            className="img-responsive"
            src="/images/pages/Untitled-8.png"
            alt=""
            style={{ width: "540px" }}
          />
          <br />

          <div className="card-header">Business Distinction</div>

          <div className="card-text">
            At CDC we differentiate the staffing business with our distinct
            style, approach and experience. We add value during onboarding,
            training, screening and assessment stages.
          </div>
        </div>

        {/* Card 2 */}
        <div className="card-main">
          <img
            className="img-responsive"
            src="/images/pages/Untitled-5.png"
            alt=""
            style={{ width: "540px" }}
          />
          <br />

          <div className="card-header">Young Professionals</div>

          <div className="card-text">
            Early career professionals can benefit from job placements, training
            and access to opportunities through CDC.
          </div>
        </div>
      </div>
</div>
    </div>
  );
};

export default BusinessClassification;
